import { PageButtonSchema } from '@/views/sports/components/PageButton/styles/PageButton.styles';

export const pageButtonStyles: PageButtonSchema = {
  button: {
    variant: 'unstyled',
    fontSize: '2xs',
    textShadow: 'none',
    color: 'white',
    h: 'fit-content',
    textTransform: 'uppercase',
    sx: {
      '&&': {
        fontFamily: 'accent',
        fontWeight: 'bold',
      },
      svg: {
        bg: 'beta.300',
        p: '0.5',
        color: '#0b3a48',
        borderRadius: 'sm',
      },
    },

    _hover: {
      color: 'beta.300',
    },
  },
};
